module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-4.812bbb3a.png";